<div class="ion-content animate__animated animate__fadeIn animate__faster">
  <div class="loading-spinner splash-image">
    <div class="center-bottom-spinner"><mat-spinner diameter="70"></mat-spinner></div>
  </div>
</div>